import React from "react";
import { useNavigate } from "react-router-dom";

export default function AdministrationHub() {
  const navigate = useNavigate();

  const items = [
    {
      title: "Company Profile",
      description: "Configure letterhead details, bank settings, PAN, and primary corporate contacts.",
      route: "/admin/company-profile",
      icon: "corporate_fare",
      color: "bg-blue-100 text-blue-700",
    },
    {
      title: "Engineers Database",
      description: "Manage engineer credentials, tracking frequencies, and live check-in statuses.",
      route: "/engineers",
      icon: "engineering",
      color: "bg-indigo-100 text-indigo-700",
    },
    {
      title: "Accounts Personnel",
      description: "Configure logins, designations, and specific role credentials for accounting staff.",
      route: "/admin/accounts",
      icon: "manage_accounts",
      color: "bg-emerald-100 text-emerald-700",
    },
    {
      title: "Future Admin Users",
      description: "Add and authorize additional administrator credentials and onboarding links.",
      route: "/admin/user-management/admins",
      icon: "admin_panel_settings",
      color: "bg-amber-100 text-amber-700",
    },
    {
      title: "Roles & Permissions",
      description: "Define custom access permissions and security authorizations.",
      route: "/admin/roles-permissions",
      icon: "rule",
      color: "bg-cyan-100 text-cyan-700",
    },
    {
      title: "Recycle Bin",
      description: "Review and restore recently deleted customers, complaints, quotations, or sales invoices.",
      route: "/admin/recycle-bin",
      icon: "delete",
      color: "bg-rose-100 text-rose-700",
    },
    {
      title: "Backup & Restore",
      description: "Export full database dumps or restore settings to previous states.",
      route: "/admin/backup-restore",
      icon: "backup",
      color: "bg-teal-100 text-teal-700",
    },
    {
      title: "System Settings",
      description: "Configure integration APIs, tokens, limits, and system parameters.",
      route: "/admin/system-settings",
      icon: "tune",
      color: "bg-slate-100 text-slate-700",
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <span className="font-label-caps text-[11px] text-primary uppercase mb-1 block">ADMIN WORKSPACE</span>
        <h1 className="font-headline-lg text-headline-lg text-on-surface">Administration</h1>
        <p className="text-sm text-outline mt-1">Select an administration tool to manage users, profile records, backups, and configurations.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((item) => (
          <button
            key={item.route}
            onClick={() => navigate(item.route)}
            className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-primary/30 transition-all text-left flex items-start gap-4 active:scale-[0.98] w-full"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${item.color}`}>
              <span className="material-symbols-outlined text-2xl">{item.icon}</span>
            </div>
            <div className="flex-1 space-y-1">
              <h3 className="text-base font-bold text-on-surface flex items-center justify-between">
                {item.title}
                <span className="material-symbols-outlined text-outline-variant text-sm group-hover:text-primary">arrow_forward</span>
              </h3>
              <p className="text-sm text-outline leading-relaxed">{item.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
